<template>
	<div>
		<h2 class="text-center">Récapitulatif</h2>

		<hr />

		<h3>Entreprise</h3>
		<p>Nom : <b class="text-primary">{{ company.name }}</b></p>
		<p>Activité : <b class="text-primary">{{ company.activity }}</b></p>
		<p>Forme juridique de l'entreprise : <b class="text-primary">{{ company.legalForm }}</b></p>
		<p>Adresse de domiciliation : <b class="text-primary">{{ domiciliation.address.name }}</b></p>
		<p>Domicliation pour un : <b class="text-primary">{{ domiciliation.status }}</b></p>
		<p>Type de domiciliation : <b class="text-primary">{{ domiciliation.type }}</b></p>

		<p v-if="domiciliation.type === 'Transfert' && domiciliation.status === 'Siège social'">Siège social : <b class="text-primary">{{ company.address.place }}<span v-if="company.address.place && company.address.zipCode">,</span> {{ company.address.zipCode }} {{ company.address.city }}</b></p>

		<p v-else-if="domiciliation.type === 'Transfert' && domiciliation.status === 'Etablissement secondaire'">Etablissement secondaire : <b class="text-primary">{{ company.address.place }}<span v-if="company.address.place && company.address.zipCode">,</span> {{ company.address.zipCode }} {{ company.address.city }}</b></p>

		<hr />

		<h3>Coordonnées</h3>
		<p>Nom : <b class="text-primary">{{ particulars.name.firstName }} {{ particulars.name.lastName }}</b></p>
		<p>Qualité : <b class="text-primary">{{ particulars.quality }}</b></p>
		<p>Né le : <b class="text-primary" v-if="particulars.birth.day">{{ particulars.birth.day }}</b> <span v-if="particulars.birth.day && particulars.birth.place.city">à</span> <b class="text-primary">{{ particulars.birth.place.city }} <span v-if="particulars.birth.place.zipCode">({{ particulars.birth.place.zipCode }})</span><span v-if="particulars.birth.place.country">, {{ particulars.birth.place.country }}</span></b></p>
		<p>Adresse : <b class="text-primary">{{ particulars.address.place }}<span v-if="particulars.address.place && particulars.address.zipCode">,</span> {{ particulars.address.zipCode }} {{ particulars.address.city }}</b></p>
		<p>Téléphone : <b class="text-primary">{{ particulars.phone }}</b></p>
		<p>Email : <b class="text-primary">{{ particulars.mailAddress }}</b></p>

		<hr />

		<h3>Courrier</h3>
		<div v-for="(activeMailOption, index) in activeOptions(mailOptions)" :key="index" class="d-flex align-items-center pl-3 mb-2 border border-primary rounded bg-white">
			<img :src="activeMailOption.image.src" :alt="activeMailOption.image.alt" width="30" height="auto" class="mr-3" />
			<p class="mt-3">{{ activeMailOption.text }}</p>
		</div>

		<hr />

		<h3>Options</h3>

		<div class="d-flex align-items-center pl-3 mb-2 border border-primary rounded bg-white" v-if="activePack(packs) != null">
			<img :src="activePack(packs).image.src" :alt="activePack(packs).image.alt" width="30" height="auto" class="mr-3" />
			<p class="mt-3">{{ activePack(packs).text }}</p>
		</div>

		<div v-for="(activeOption, index) in activeOptions(options)" :key="index" class="d-flex align-items-center pl-3 mb-2 border border-primary rounded bg-white">
			<img :src="activeOption.image.src" :alt="activeOption.image.alt" width="30" height="auto" class="mr-3" />
			<p class="mt-3">{{ activeOption.text }}</p>
		</div>

		<hr />

		<b-row class="mb-5">
			<b-col>
				<h3>Total</h3>
				<p class="text-muted">+ TVA</p>
				<p class="text-muted">+ Dépôt de garantie</p>
			</b-col>

			<b-col cols="auto">
				<p class="h3">{{ price.withOptions }}€ HT</p>
				<p class="text-muted">{{ priceWithTaxes(price.withOptions) }}€ TTC</p>
				<p class="text-muted">{{ priceWithTaxesNwarrantyDeposit(priceWithTaxes(price.withOptions), price.warrantyDeposit) }}€ TTC</p>
			</b-col>
		</b-row>

		<div>
			<p class="text-black-50">
				Système de paiement propulsé par Stripe, leader du marché selon Forrester Wave™, respectant les normes de certification les plus strictes afin d'assurer la sécurité des paiements.
			</p>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto">
					<img src="../../assets/images/icons/certifications/pci.svg" alt="PCI Certification" width="50" height="auto" />
				</b-col>

				<b-col>
					<p class="text-white">Certification PCI DSS de niveau 1</p>
				</b-col>
			</b-row>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto">
					<img src="../../assets/images/icons/certifications/europe.svg" alt="Etoiles Européennes" width="50" height="auto" />
				</b-col>

				<b-col>
					<p class="text-white">Conforme à la directive européenne DSP2 et à l'authentification forte du client</p>
				</b-col>
			</b-row>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto" class="text-white text-center">
					<img src="../../assets/images/icons/certifications/aicpa-soc.svg" alt="AICPA / SOC" width="50" height="auto" />
				</b-col>


				<b-col>
					<p class="text-white">Rapports SSAE18/SOC 1 type 1 et 2 et SSAE18/SOC 2 type 1 et 2</p>
				</b-col>
			</b-row>

			<b-row class="bg-gray rounded mx-0 mb-3 justify-content-center align-items-center p-3">
				<b-col cols="auto" class="text-white text-center">
					<img src="../../assets/images/icons/certifications/world.svg" alt="Terre" width="50" height="auto" />
				</b-col>

				<b-col>
					<p class="text-white">Licence AFSL en Australie, licence d'établissement de monnaie électronique en Europe et enregistrement comme entreprise de services monétaires (ESM) au Canada</p>
				</b-col>
			</b-row>

			<div class="d-flex justify-content-between align-items-center">
				<img src="../../assets/images/icons/payment_cards/visa.svg" alt="VISA" width="50" height="auto" />
				<img src="../../assets/images/icons/payment_cards/mastercard.svg" alt="Master Card" width="50" height="auto" />
				<img src="../../assets/images/icons/payment_cards/american-express.svg" alt="American Express" width="50" height="auto" />
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        props: {
            company: {
                type: Object
            },
            domiciliation: {
                type: Object
            },
            particulars: {
                type: Object
            },
            mailOptions: {
                type: Array
            },
            packs: {
                type: Array
            },
            options: {
                type: Array
            },
            price: {
                type: Object,
                required: true
            }
        },
        methods : {
            activePack(packs) {
                let activePack = null

                packs.forEach((pack) => {
                    if (pack.active === true)  {
                        activePack = pack;
                    }
                });

                return activePack;
            },
            activeOptions(options) {
                let activeOptions = [];

                options.forEach((option) => {
                    if (option.active === true)  {
                        activeOptions.push(option);
                    }
                });

                return activeOptions;
            },
            priceWithTaxes(initialPrice) {
                return Math.round(initialPrice * (1 + 20 / 100));
            },
            priceWithTaxesNwarrantyDeposit(priceWithTaxes, warrantyDeposit) {
                return priceWithTaxes + warrantyDeposit;
            }
        }
    }
</script>
